import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'

@Injectable()
export class CommonService {
  cityList: any;
  noResult: boolean;
  selectedOption : any;
  constructor(private http: HttpClient) { }
  

  

  onSelectCity(event){
    if(this.selectedOption == event.item) {
      return true;
    }
    else {
      return false;
    }
  }

  checkCityValue(event,cityList){
    if(event.target.value){
      let cityValue = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1);
      if(!cityList.includes(cityValue)){
        return true;
      }else {
        return false;
      }
    }
  }
    
}
